var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SmartLink',{staticClass:"btn btn-cta btn-primary",attrs:{"destination":_vm.url,"data-qa":"call to action","hide-external-icon":""}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }